import {Box, Icon, Text} from "@chakra-ui/react";

const IconWithBadge = ({ icon, label,  color = "blue.500" }) => {
    return (
        <Box position="relative" display="inline-block">
            <Icon as={icon} />
            {label && (
                <Text
                    color={color}
                    fontWeight="bold"
                    position={'absolute'}
                    fontSize="9px"
                    textShadow="0px 0px 3px white, 0px 0px 3px white"
                    top="-8px"
                    right="-14px">
                        {label}
                </Text>
            ) }
        </Box>
    );
};

export default IconWithBadge;